import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import styled from 'styled-components';

const MOBILE_BREAKPOINT = '960px';

const navItems = [
  { to: '/classroom-teacher', label: 'Dashboard', end: true },
  { to: '/classroom-teacher/classes', label: 'Classes' },
  { to: '/classroom-teacher/lessons', label: 'Lessons' },
  { to: '/classroom-teacher/quizzes', label: 'Quizzes' },
  { to: '/classroom-teacher/assignments', label: 'Assignments' },
  { to: '/classroom-teacher/grades', label: 'Grading' },
  { to: '/classroom-teacher/analytics', label: 'Analytics' },
  { to: '/classroom-teacher/communication', label: 'Messages' },
];

const Shell = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--surface);
  border: 1px solid var(--outline);
  border-radius: 16px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 1rem;
  }
`;

const Brand = styled.div`
  min-width: 0;
  margin-right: 2rem;
`;

const BrandTitle = styled.h1`
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  color: var(--primary);
  letter-spacing: -0.02em;
`;


const NavScroll = styled.div`
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.15rem;
`;

const TabLink = styled(NavLink)`
  padding: 0.5rem 0.65rem;
  font-size: 0.875rem;
  color: var(--onSurfaceVariant);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  border-radius: 8px;
  border-bottom: 2px solid transparent;
  font-family: 'Open Sans', sans-serif;
  &:hover {
    color: var(--primary);
    background: var(--surfaceVariant);
  }
  &.active {
    color: var(--primary);
    font-weight: 600;
    border-bottom-color: var(--primary);
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }
`;

const ClassroomTeacherLayout: React.FC = () => {
  return (
    <Shell>
      <TopBar>
        <Brand>
          <BrandTitle>NCOF Classroom</BrandTitle>
          
        </Brand>
        <NavScroll>
          <Nav>
            {navItems.map((item) => (
              <TabLink key={item.to} to={item.to} end={item.end ?? false}>
                {item.label}
              </TabLink>
            ))}
          </Nav>
        </NavScroll>
      </TopBar>
      <Outlet />
    </Shell>
  );
};

export default ClassroomTeacherLayout;
